<template>
  <b-row>
    <b-col cols="12">
      <user-payments-table :key="$route.fullPath" />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import UserPaymentsTable from './UserPaymentsTable.vue'

export default {
  components: {
    BRow,
    BCol,
    UserPaymentsTable,
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
